export const spanishRaMessages = {
  ra: {
    action: {
      add_filter: "Agregar filtro",
      add: "Agregar",
      back: "Volver",
      bulk_actions:
        "1 elemento seleccionado |||| %{smart_count} elementos seleccionados",
      cancel: "Cancelar",
      clear_array_input: "Vaciar la lista",
      clear_input_value: "Limpiar valor",
      clear_search: "Limpiar búsqueda",
      clone: "Duplicar",
      confirm: "Confirmar",
      create: "Crear",
      create_item: "Crear %{item}",
      delete: "Eliminar",
      edit: "Editar",
      export: "Exportar",
      list: "Lista",
      refresh: "Actualizar",
      remove_filter: "Quitar este filtro",
      remove_all_filters: "Quitar todos los filtros",
      remove: "Quitar",
      reset: "Restablecer",
      save: "Guardar",
      search: "Buscar",
      search_columns: "Buscar columnas",
      select_all: "Seleccionar todo",
      select_all_button: "Seleccionar todo",
      select_row: "Seleccionar esta fila",
      show: "Mostrar",
      sort: "Ordenar",
      undo: "Deshacer",
      unselect: "Deseleccionar",
      expand: "Expandir",
      close: "Cerrar",
      open_menu: "Abrir menú",
      close_menu: "Cerrar menú",
      update: "Actualizar",
      move_up: "Mover hacia arriba",
      move_down: "Mover hacia abajo",
      open: "Abrir",
      toggle_theme: "Cambiar tema claro/oscuro",
      select_columns: "Columnas",
      update_application: "Recargar aplicación",
    },
    boolean: { false: "No", null: "Sin definir", true: "Sí" },
    page: {
      create: "Crear %{name}",
      dashboard: "Inicio",
      edit: "Editar %{name}",
      error: "Ocurrió un error",
      list: "%{name}",
      loading: "Cargando",
      not_found: "No encontrado",
      show: "%{name}",
      empty: "Aún no hay %{name}.",
      invite: "¿Quieres agregar uno?",
      access_denied: "Acceso denegado",
      authentication_error: "Error de autenticación",
    },
    input: {
      file: {
        upload_several: "Arrastra archivos o haz clic para seleccionarlos.",
        upload_single: "Arrastra un archivo o haz clic para seleccionarlo.",
      },
      image: {
        upload_several: "Arrastra imágenes o haz clic para seleccionarlas.",
        upload_single: "Arrastra una imagen o haz clic para seleccionarla.",
      },
      references: {
        all_missing: "No se encontraron las referencias.",
        many_missing: "Algunas referencias asociadas ya no están disponibles.",
        single_missing: "La referencia asociada ya no está disponible.",
      },
      password: {
        toggle_visible: "Ocultar contraseña",
        toggle_hidden: "Mostrar contraseña",
      },
    },
    message: {
      about: "Acerca de",
      access_denied: "No tienes permiso para acceder a esta página.",
      are_you_sure: "¿Estás seguro?",
      authentication_error:
        "El servidor de autenticación devolvió un error y no se pudieron verificar tus credenciales.",
      auth_error: "Ocurrió un error al validar el token de autenticación.",
      bulk_delete_content:
        "¿Seguro que deseas eliminar este elemento? |||| ¿Seguro que deseas eliminar estos %{smart_count} elementos?",
      bulk_delete_title:
        "Eliminar %{name} |||| Eliminar %{smart_count} %{name}",
      bulk_update_content:
        "¿Seguro que deseas actualizar este elemento? |||| ¿Seguro que deseas actualizar estos %{smart_count} elementos?",
      bulk_update_title:
        "Actualizar %{name} |||| Actualizar %{smart_count} %{name}",
      clear_array_input: "¿Seguro que deseas vaciar toda la lista?",
      delete_content: "¿Seguro que deseas eliminar este %{name}?",
      delete_title: "Eliminar %{name}",
      details: "Detalles",
      error: "Ocurrió un error y la solicitud no se completó.",
      invalid_form: "El formulario no es válido. Revisa los errores.",
      loading: "Espera un momento",
      no: "No",
      not_found:
        "La dirección es incorrecta o el enlace ya no está disponible.",
      select_all_limit_reached:
        "Hay demasiados elementos. Solo se seleccionaron los primeros %{max}.",
      unsaved_changes:
        "Algunos cambios no se guardaron. ¿Seguro que deseas descartarlos?",
      yes: "Sí",
      placeholder_data_warning:
        "Problema de red: no se pudieron actualizar los datos.",
    },
    navigation: {
      clear_filters: "Limpiar filtros",
      no_filtered_results:
        "No se encontraron %{name} con los filtros actuales.",
      no_results: "No se encontraron %{name}",
      no_more_results:
        "La página %{page} está fuera de rango. Prueba la página anterior.",
      page_out_of_boundaries: "La página %{page} está fuera de rango",
      page_out_from_end: "No puedes avanzar más allá de la última página",
      page_out_from_begin: "No puedes retroceder antes de la página 1",
      page_range_info: "%{offsetBegin}-%{offsetEnd} de %{total}",
      partial_page_range_info:
        "%{offsetBegin}-%{offsetEnd} de más de %{offsetEnd}",
      current_page: "Página %{page}",
      page: "Ir a la página %{page}",
      first: "Ir a la primera página",
      last: "Ir a la última página",
      next: "Ir a la página siguiente",
      previous: "Ir a la página anterior",
      page_rows_per_page: "Filas por página:",
      skip_nav: "Ir al contenido",
    },
    sort: {
      sort_by: "Ordenar por %{field_lower_first} %{order}",
      ASC: "ascendente",
      DESC: "descendente",
    },
    auth: {
      auth_check_error: "Inicia sesión para continuar",
      user_menu: "Perfil",
      username: "Usuario",
      password: "Contraseña",
      email: "Correo electrónico",
      sign_in: "Iniciar sesión",
      sign_in_error: "No fue posible iniciar sesión. Inténtalo nuevamente.",
      logout: "Cerrar sesión",
    },
    notification: {
      updated:
        "Elemento actualizado |||| %{smart_count} elementos actualizados",
      created: "Elemento creado",
      deleted: "Elemento eliminado |||| %{smart_count} elementos eliminados",
      bad_item: "Elemento incorrecto",
      item_doesnt_exist: "El elemento ya no existe",
      http_error: "Error de comunicación con el servidor",
      data_provider_error:
        "Error del proveedor de datos. Revisa la consola para más detalles.",
      i18n_error: "No se pudieron cargar las traducciones del idioma indicado",
      canceled: "Acción cancelada",
      logged_out: "Tu sesión terminó. Vuelve a iniciar sesión.",
      not_authorized: "No tienes autorización para acceder a este recurso.",
      application_update_available: "Hay una nueva versión disponible.",
      offline: "Sin conexión. No se pudieron obtener los datos.",
    },
    validation: {
      required: "Campo obligatorio",
      minLength: "Debe tener al menos %{min} caracteres",
      maxLength: "Debe tener %{max} caracteres o menos",
      minValue: "Debe ser al menos %{min}",
      maxValue: "Debe ser %{max} o menos",
      number: "Debe ser un número",
      email: "Debe ser un correo electrónico válido",
      oneOf: "Debe ser uno de estos valores: %{options}",
      regex: "Debe coincidir con el formato requerido: %{pattern}",
      unique: "Debe ser único",
    },
    saved_queries: {
      label: "Consultas guardadas",
      query_name: "Nombre de la consulta",
      new_label: "Guardar consulta actual...",
      new_dialog_title: "Guardar consulta actual como",
      remove_label: "Quitar consulta guardada",
      remove_label_with_name: "Quitar consulta «%{name}»",
      remove_dialog_title: "¿Quitar consulta guardada?",
      remove_message:
        "¿Seguro que deseas quitar este elemento de tus consultas guardadas?",
      help: "Filtra la lista y guarda esta consulta para usarla después",
    },
    guesser: {
      empty: {
        title: "No hay datos para mostrar",
        message: "Revisa el proveedor de datos",
      },
    },
    configurable: {
      customize: "Personalizar",
      configureMode: "Configurar esta página",
      inspector: {
        title: "Inspector",
        content: "Pasa el cursor sobre los elementos para configurarlos",
        reset: "Restablecer configuración",
        hideAll: "Ocultar todo",
        showAll: "Mostrar todo",
      },
      Datagrid: {
        title: "Tabla de datos",
        unlabeled: "Columna sin etiqueta n.º %{column}",
      },
      SimpleForm: {
        title: "Formulario",
        unlabeled: "Campo sin etiqueta n.º %{input}",
      },
      SimpleList: {
        title: "Lista",
        primaryText: "Texto principal",
        secondaryText: "Texto secundario",
        tertiaryText: "Texto terciario",
      },
    },
  },
} as const;
